import React, { useState } from "react";
import { Box, Typography } from "@mui/material";

import { purple } from "../../../shared/theme/colors";

export default function AuthTextField({
  label,
  required,
  icon,
  error,
  helperText,
  endAdornment,
  type = "text",
  value,
  onFocus,
  onBlur,
  ...inputProps
}) {
  const [focused, setFocused] = useState(false);

  return (
    <Box
      sx={{
        mb: helperText ? 1 : 1.5,
        "@media (max-height: 560px)": {
          mb: helperText ? 0.75 : 1,
        },
      }}
    >
      <Typography
        component="label"
        htmlFor={inputProps.id || inputProps.name}
        sx={{
          display: "block",
          mb: 0.75,
          color: "#0F172A",
          fontFamily: "Inter, Roboto, Helvetica, Arial, sans-serif",
          fontSize: 14,
          fontWeight: 500,
          lineHeight: "20px",
          "@media (max-height: 560px)": {
            mb: 0.5,
          },
        }}
      >
        {label}
        {required ? " *" : ""}
      </Typography>

      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          width: "100%",
          height: 48,
          bgcolor: "#FFFFFF",
          border: "1px solid",
          borderColor: error
            ? "#DC2626"
            : focused
              ? purple[600]
              : "#CBD5E1",
          borderRadius: "4px",
          transition: "border-color 160ms ease, box-shadow 160ms ease",
          "&:hover": {
            borderColor: error ? "#DC2626" : "#94A3B8",
          },
          "&:focus-within": {
            boxShadow: error
              ? "0 0 0 1px rgba(220, 38, 38, 0.18)"
              : "0 0 0 1px rgba(129, 66, 252, 0.18)",
          },
          "@media (max-height: 560px)": {
            height: 46,
          },
        }}
      >
        <Box
          sx={{
            display: "grid",
            placeItems: "center",
            width: 48,
            flex: "0 0 48px",
            zIndex: 1,
            color: error ? "#DC2626" : "#64748B",
            opacity: 0.7,
            "& svg": {
              width: 19,
              height: 19,
            },
            "@media (max-height: 560px)": {
              width: 46,
              flexBasis: 46,
            },
          }}
        >
          {icon}
        </Box>

        <Box
          component="input"
          id={inputProps.id || inputProps.name}
          type={type}
          value={value}
          onChange={inputProps.onChange}
          onFocus={(event) => {
            setFocused(true);
            onFocus?.(event);
          }}
          onBlur={(event) => {
            setFocused(false);
            onBlur?.(event);
          }}
          {...inputProps}
          sx={{
            width: "100%",
            minWidth: 0,
            height: 46,
            py: 0,
            pl: 0,
            pr: endAdornment ? "4px" : "12px",
            border: 0,
            outline: "none",
            bgcolor: "transparent",
            color: "#0F172A",
            fontFamily: "Inter, Roboto, Helvetica, Arial, sans-serif",
            fontSize: 14,
            "@media (max-height: 560px)": {
              height: 44,
            },
          }}
        />

        {endAdornment ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flex: "0 0 auto",
              zIndex: 1,
            }}
          >
            {endAdornment}
          </Box>
        ) : null}
      </Box>

      {helperText ? (
        <Typography
          sx={{
            mt: 0.5,
            pr: "12px",
            color: "#DC2626",
            fontFamily: "Inter, Roboto, Helvetica, Arial, sans-serif",
            fontSize: 12,
            lineHeight: "20px",
          }}
        >
          {helperText}
        </Typography>
      ) : null}
    </Box>
  );
}
